/** 위경도 간 거리 계산 **/
export const getDistance = (fromLatitude, fromLongitude, toLatitude, toLongitude) => {
  const R = 6371; // km
  const _lat1 = this.toRad(fromLatitude);
  const _lat2 = this.toRad(toLatitude);
  const dLat = this.toRad(toLatitude - fromLatitude);
  const dLon = this.toRad(toLongitude - fromLongitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(_lat1) * Math.cos(_lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d;
};
// Converts numeric degrees to radians
export const toRad = Value => {
  return (Value * Math.PI) / 180;
};

export default {
  getDistance,
  toRad
};
